import {
  Component,
  input,
  InputSignal,
} from '@angular/core';

@Component({
  selector: 'app-html-content',
  templateUrl: './html-content.component.html',
  styleUrl: './html-content.component.scss',
})
export class HtmlContentComponent {

  public readonly text: InputSignal<string | null> = input<string | null>('');

}
